import { memo } from 'react';

import useHoustonTheme from '@eduzz/houston-styles/useHoustonTheme';

interface IProps {
  margin?: string;
}
const Divider: React.FC<IProps> = ({ margin }) => {
  const theme = useHoustonTheme();

  return (
    <div
      style={{
        width: '100%',
        height: '1px',
        backgroundColor: theme.neutralColor.high.medium,
        margin: margin ? margin : `${theme.spacing.nano} 0`
      }}
    />
  );
};

export default memo(Divider);
